import { z } from 'zod';

export const API_TOKEN_SCOPES = ['import'] as const;
export type ApiTokenScope = (typeof API_TOKEN_SCOPES)[number];

export const apiTokenCreateSchema = z.object({ label: z.string().trim().min(1).max(60) });

export const apiTokenSchema = z.object({
  id: z.uuid(),
  label: z.string(),
  scopes: z.array(z.enum(API_TOKEN_SCOPES)),
  createdAt: z.iso.datetime(),
  lastUsedAt: z.iso.datetime().nullable(),
});
export type ApiToken = z.infer<typeof apiTokenSchema>;

/** The new token, shown once. */
export const apiTokenCreatedSchema = apiTokenSchema.extend({ token: z.string() });
export type ApiTokenCreated = z.infer<typeof apiTokenCreatedSchema>;

export const apiTokenListSchema = z.object({ tokens: z.array(apiTokenSchema) });
